import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  canonical,
  robots = "index, follow",
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterImage,
  author,
  publisher,
  schema,
}) => {
  return (
    <Helmet prioritizeSeoTags>
      {/* Basic SEO */}
      {title && <title>{title}</title>}

      {description && (
        <meta
          name="description"
          content={description}
        />
      )}

      {keywords && (
        <meta
          name="keywords"
          content={keywords}
        />
      )}

      {robots && (
        <meta
          name="robots"
          content={robots}
        />
      )}

      {canonical && (
        <link
          rel="canonical"
          href={canonical}
        />
      )}

      {/* Open Graph */}
      <meta property="og:type" content="website" />

      {ogTitle && (
        <meta
          property="og:title"
          content={ogTitle}
        />
      )}

      {ogDescription && (
        <meta
          property="og:description"
          content={ogDescription}
        />
      )}

      {ogImage && (
        <meta
          property="og:image"
          content={ogImage}
        />
      )}

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      {twitterTitle && (
        <meta
          name="twitter:title"
          content={twitterTitle}
        />
      )}

      {twitterDescription && (
        <meta
          name="twitter:description"
          content={twitterDescription}
        />
      )}

      {twitterImage && (
        <meta
          name="twitter:image"
          content={twitterImage}
        />
      )}

      {/* Author */}
      {author && (
        <meta
          name="author"
          content={author}
        />
      )}

      {/* Publisher */}
      {publisher && (
        <meta
          name="publisher"
          content={publisher}
        />
      )}

      {/* Structured Data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;